import { render } from "./RegistrationForm.vue?vue&type=template&id=45f34afe"
import script from "./RegistrationForm.vue?vue&type=script&lang=js"
export * from "./RegistrationForm.vue?vue&type=script&lang=js"

import "./RegistrationForm.vue?vue&type=style&index=0&id=45f34afe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__